import {
  jb_button_css_default
} from "./chunk.VHH4DFTQ.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  Linkable
} from "./chunk.TC6HXM2Y.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-button/jb-button.ts
var JbButton = class extends Initiable(Linkable(i)) {
  _click(clickEvent) {
    if (!this.name || this.disabled) {
      return;
    }
    this.dispatchEvent(
      new CustomEvent("jb-button:clicked", {
        detail: { name: this.name, clickEvent },
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    const tertiaryArrow = b`<svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_205_9894)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.9611 8.55537C17.2381 8.83236 17.2381 9.28142 16.9611 9.55838L12.3073 14.2122C12.0303 14.4892 11.5813 14.4892 11.3043 14.2122C11.0273 13.9352 11.0273 13.4862 11.3043 13.2092L15.4566 9.05688L11.3043 4.90454C11.0273 4.62755 11.0273 4.17849 11.3043 3.90153C11.5812 3.62456 12.0303 3.62454 12.3073 3.90153L16.9611 8.55537Z"
          fill="#141E55"
        />
        <rect
          x="1.14893"
          y="8.29999"
          width="15"
          height="1.5"
          fill="#141E55"
        />
      </g>
      <defs>
        <clipPath id="clip0_205_9894">
          <rect
            width="16"
            height="12"
            fill="white"
            transform="translate(1.14893 3)"
          />
        </clipPath>
      </defs>
    </svg> `;
    return b`
      ${this.icon === "video" ? b`<jb-play-pause-button></jb-play-pause-button>` : A}
      <div
        class=${e({
      disabled: this.disabled || false,
      forcehover: this.forceHover || false,
      fullwidth: this.fullWidth || false,
      white: this.white || false,
      primary: this.variant === "primary",
      secondary: this.variant === "secondary" || this.variant === void 0,
      tertiary: this.variant === "tertiary",
      arrowright: this.tertiaryArrowDirection === "right" || this.tertiaryArrowDirection === void 0,
      arrowup: this.tertiaryArrowDirection === "up",
      arrowdown: this.tertiaryArrowDirection === "down"
    })}
      >
        <a
          data-linkable
          class=${e({ icon: this.icon || false })}
          @click=${this._click}
        >
          ${this.icon === "mail" ? b`<jb-icon iconName="material:mail"></jb-icon>` : A}
          ${this.icon === "print" ? b`<jb-print-icon></jb-print-icon>` : A}
          <span>${this.text} ${this.variant === "tertiary" ? tertiaryArrow : A}</span>
        </a>
      </div>
    `;
  }
};
JbButton.styles = [reset_css_default, jb_button_css_default];
__decorateClass([
  n({ type: Boolean })
], JbButton.prototype, "disabled", 2);
__decorateClass([
  n({ type: Boolean })
], JbButton.prototype, "forceHover", 2);
__decorateClass([
  n({ type: Boolean })
], JbButton.prototype, "fullWidth", 2);
__decorateClass([
  n()
], JbButton.prototype, "icon", 2);
__decorateClass([
  n()
], JbButton.prototype, "name", 2);
__decorateClass([
  n()
], JbButton.prototype, "tertiaryArrowDirection", 2);
__decorateClass([
  n()
], JbButton.prototype, "text", 2);
__decorateClass([
  n()
], JbButton.prototype, "variant", 2);
__decorateClass([
  n({ type: Boolean })
], JbButton.prototype, "white", 2);
JbButton = __decorateClass([
  customElement("jb-button")
], JbButton);

export {
  JbButton
};
